import "./workingSteps.css";

const steps = [
  {
    number: "1",
    title: "Lets Connected One On One",
    text: "We start by talking directly, learning what you want and prefer.",
    details: [
      { label: "Submit Form", desc: "Just fill out the form, and tell us simply what you need for your project design. It helps us get started right." },
      { label: "Schedule A Free Call", desc: "Chat live with our experts about your Project Space and design concepts. Pick a time that works for you.", milestone: "Idea Exploration Meeting" }
    ]
  },
  {
    number: "2",
    title: "Begin Your Design",
    text: "Here, we work together to build a design that matches your ideas and needs.",
    details: [
      /*{ label: "Pay The Design Fee", desc: "If you're happy with the session and we're aligned on your needs, choose a design plan to start." },*/
      { label: "2D Design", desc: "Our designers draw a clear 2D plan of your project, showing exactly where deities/stone art fit and how they look."},
      { label: "3D Design", desc: "With the 2D plan approved, picture your ideal space vividly using a 3D model."},
      { label: "Approve the Final Design", desc: "Once you approve the design, we can then proceed directly into the production phase.", milestone: "2D & 3D Design Are Finalized"  }
    ]
  },
  {
    number: "3",
    title: "Place The Order",
    text: "After the design is complete, you're ready to order your custom Project.",
    details: [
        { label: "Work Begins", desc: "Once you place the order, our skilled artisans begin crafting your project with care and precision." },
        { label: "Production Updates", desc: "We keep you informed with regular updates(Photos, Vidoes) on the progress of your project.", milestone: "Production In Progress" },
        { label: "Quality Check", desc: "Before delivery, we thoroughly inspect your project to ensure it meets our high standards and your expectations.", milestone: "Production Completed" }
    ]
  },
  {
    number: "4",
    title: "Delivery & Installation",
    text: "At last, your pooja room is delivered and installed by us at your chosen spot.",
    details: [
        { label: "Packaging", desc: "We carefully package your project to ensure it arrives safely and in perfect condition." },
        { label: "Delivery", desc: "We deliver your project to your specified location, ensuring it arrives on time and in excellent condition, **whether nationally or internationally.**" },
        { label: "Installation", desc: "Our expert team installs your project with precision and care, ensuring everything is perfect.", milestone: "Project Delivered & Installed" }
    ]
}
];

const WorkingSteps = () => {
  return (
    <div className="steps-section">
      <h2 className="steps-header">Design Your Project In 4 Easy Steps</h2>
      <p className="steps-subtext">
        Get your dream Project with us. Our 4-step process designs and delivers it right to your door.
      </p>

      <div className="steps-container">
        {steps.map((step, i) => (
          <div className="step-card" key={i}>
            <div className="step-number">{step.number}</div>
            <div className="step-content">
              <h3 className="step-title">{step.title}</h3>
              <p className="step-text">{step.text}</p>

              {step.details && (
                <div className="step-details-box">
                  {step.details.map((d, j) => (
                    <div key={j} className="detail-item">
                      <span className="detail-dot">●</span>
                      <div className="detail-content">
                        <p className="detail-label">{d.label}</p>
                        {d.milestone && (
                          <span className="detail-milestone">
                            Milestone: {d.milestone}
                          </span>
                        )}
                        <p className="detail-desc">{d.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkingSteps;
